import React from 'react';

const FeatureTile = ({ title, description, index = 0 }) => {
    const delayClass = `animation-delay-${Math.min(index + 1, 6)}00`;

    return (
        <div className={`glass-panel p-8 hover:transform hover:-translate-y-2 transition-transform duration-300 animate-fade-in-up opacity-0 ${delayClass}`}>
            <h3 className="text-2xl font-bold mb-4 text-primary-blue">{title}</h3>
            <p className="text-text-light">{description}</p>
        </div>
    );
};

export default FeatureTile;
